import { AFTER_MUTATION } from "./afterMutation";
// the reminder phase has to follow every enforcement action, so no call site can forget a key
export var invalidateDepositRecordViews = function (queryClient) {
    queryClient.invalidateQueries(["deposit-records-by-title"], undefined, AFTER_MUTATION);
    queryClient.invalidateQueries(["deposit-record-timeline"], undefined, AFTER_MUTATION);
    queryClient.invalidateQueries(["reminder-status"], undefined, AFTER_MUTATION);
    // The send dialog's selection phase is built from this preview and it is cached for 30 s. Left
    // stale, a title urged a second ago comes back as never enforced: unbadged, back in "Bez
    // urgence" and preselected again — so a second click sends a second mail to the publisher.
    queryClient.invalidateQueries(["urgence-preview"], undefined, AFTER_MUTATION);
};
